import { CommonModule as AngularCommonModule } from '@angular/common';
import { DnForgotPasswordModule, NotyService } from '@dn/libs/ui/dn-common';
import { CommonModule } from '../common/common.module';
import { NgModule } from '@angular/core';

import { ResetPasswordRoutingModule } from './reset-password-routing.module';
import { ResetPasswordComponent } from './reset-password.component';
import { config } from '../../environments/config';

@NgModule({
  declarations: [ResetPasswordComponent],
  imports: [CommonModule, AngularCommonModule, ResetPasswordRoutingModule, DnForgotPasswordModule.forRoot(config.name)],
  providers: [NotyService],
})
export class ResetPasswordModule {}
